<template>
  <v-select
    v-model="selected"
    chips
    hide-details
    multiple
    outlined
    dense
    label="Filtros"
    placeholder="Selecione os Filtros"
    :items="filters"
    clearable
  >
    <template v-slot:selection="{ item, index }">
      <v-chip v-if="index === 0" small color="green" dark>
        <span class="caption">{{ item.text }}</span>
      </v-chip>
      <v-chip small color="blue-grey lighten-4" dark v-if="index === 1">
        <i>(+{{ selected.length - 1 }})</i>
      </v-chip>
    </template>
  </v-select>
</template>

<script>
export default {
  props: {
    filters: Array,
    value: Array,
  },
  data: () => ({
    selected: [],
  }),
  watch: {
    selected() {
      this.$emit('input', this.selected)
    },
  },
  mounted() {
    this.selected = this.value
  },
}
</script>

<style></style>
